import React, { useContext, useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { DashboardContext } from 'live/context/dashboard'
import './assets/widget-icon.scss'

const Wrapper = styled.div`
    height: 100%;
    display: flex;
    flex-flow: column;

    .text-value3 {
        font: 13.1415px / 120% SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
        text-rendering: optimizeLegibility;
        padding: 0px 2px;
        margin: auto 0;
        color: ${props => (props.theme === 'light' ? '#364159' : '#FFFFFF')};
        width: min-content;
        white-space: nowrap;
    }
`

const getFontSize = div => {
    let fontSize = window.getComputedStyle(div, null).getPropertyValue('font-size')
    return Number(fontSize.substring(0, fontSize.length - 2))
}

const calculateFontSize = (dimension, padding, div, divDimension) =>
    (dimension - 2 * padding) / (divDimension / getFontSize(div))

const calculateMinFontSize = (width, height, padding, div) =>
    Math.min(
        calculateFontSize(width, padding, div, div.offsetWidth),
        calculateFontSize(height, padding, div, div.offsetHeight)
    )

const changeFonts = (div: HTMLElement, width: number, height: number) => {
    if (div) {
        let maxFontSizes = [].slice
            .call(document.getElementsByClassName('text-value3'))
            .map(divComponent =>
                calculateMinFontSize(
                    divComponent.parentElement.clientWidth,
                    divComponent.parentElement.clientHeight,
                    5,
                    divComponent
                )
            )

        let selectedFont = Math.min.apply(null, maxFontSizes)

        return [].slice
            .call(document.getElementsByClassName('text-value3'))
            .map(divComponent => (divComponent.style.fontSize = selectedFont + 'px'))
    }
}

export default (props: any) => {
    const { ...context } = useContext(DashboardContext)
    const textRef = useRef(null)

    useEffect(() => {
        changeFonts(textRef.current, props.width, props.height)
    }, [textRef.current, props.width, props.height, props.value])

    if (props.value === ' ') return null

    return (
        <Wrapper theme={context.theme}>
            <div ref={textRef} className="text-value3">
                {props.value}
            </div>
        </Wrapper>
    )
}
